function cleanUrl(url) {
	return url.replaceAll(/[^A-Za-z0-9/]+/g, '-').toLowerCase();
}

export function facilityUrl(facility) {
	if (!facility?.seoLocation) {
		return '';
	}
	const { id, seoLocation, name, inNetwork } = facility;
	const { city, fullState } = seoLocation;
	const title = `${name.replaceAll(/[^a-z0-9]/gi, '-')}-${id}`;
	let url = `/self-storage/${fullState}/${city}/${inNetwork ? '' : 'ogf/'}${title}/`;
	url = cleanUrl(url);
	return url;
}
